export const SHOW_CONFIRM = 'showConfirm';
export const SHOW_MODAL = 'showModal';
